/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfListOfNavigationItemDto } from '../../models/platform-api-result-of-list-of-navigation-item-dto';
import { PlatformReorderNavigationItem } from '../../models/platform-reorder-navigation-item';

export interface PostNavigationitemsActionReorder$Params {
      body: PlatformReorderNavigationItem
}

export function postNavigationitemsActionReorder(http: HttpClient, rootUrl: string, params: PostNavigationitemsActionReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfNavigationItemDto>> {
  const rb = new RequestBuilder(rootUrl, postNavigationitemsActionReorder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfListOfNavigationItemDto>;
    })
  );
}

postNavigationitemsActionReorder.PATH = '/api/navigationitems/action/reorder';
